import { render, staticRenderFns } from "./NetworkNotifier.vue?vue&type=template&id=27dc5e38"
import script from "./NetworkNotifier.vue?vue&type=script&lang=js"
export * from "./NetworkNotifier.vue?vue&type=script&lang=js"
import style0 from "./NetworkNotifier.vue?vue&type=style&index=0&id=27dc5e38&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports